import React, { useState, useEffect } from 'react'
import Loader from '../Loader/Loader'
import { AiFillDelete, AiFillEdit, AiOutlineEye } from "react-icons/ai";
import { message } from "antd";
import { Pagination, Tooltip } from 'antd';
import CustomModal from "../Modals/CustomModal";
import { getSupport, deleteStaff } from '../../webServices/Apis';
import ViewSupport from './ViewSupport';
import CreateSupport from './CreateSupport';
import EditSupport from './EditSupport';

const SupportStaff = () => {

    const [allStaff, setAllStaff] = useState([])
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [action , setAction] = useState(false)
    const [selectedStaff, setSelectedStaff] = useState({})

    const [showCreateModal, setShowCreateModal] = useState(false)
    const [viewModalOpen, setViewModalOpen] = useState(false)
    const [editModalOpen, setEditModalOpen] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)


    const handlePageChange = (page) => {
        setCurrentPage(page);
      };


      // Slice the subcontractors based on current page and items per page
  const currentItems = allStaff.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );


    const handleCreateModalOpen = () => {
        setShowCreateModal(true)
    }

    const handleViewModalOpen = (staff) => {
        setSelectedStaff(staff)
        setViewModalOpen(true)
    }

    const handleEditModalOpen = (staff) => {
        setSelectedStaff(staff)
        setEditModalOpen(true)
    }

    const handleDeleteModalOpen = (staff) => {
        setSelectedStaff(staff)
        setDeleteModalOpen(true)
    }

    const handleDeleteModalClose = () => {
        setSelectedStaff("")
        setDeleteModalOpen(false)
    }

    const fetchSupportStaff = async () => {
        try {
            setLoading(true)
            const response = await getSupport()
            if (response?.data?.success) {

                const reverseOrder = [...response?.data?.data].reverse()
                setAllStaff(reverseOrder)
            }
        } catch (error) {
            console.log("Error fetching subcontractors:", error);
            if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
                // Handle internet disconnection
                return;
            }
            // Handle specific error cases
            if (error?.response?.status === 401) {
                window.alert("Your account is logged in to another device, please login again !")
                localStorage.removeItem('token');
                // setIsAuthenticated(false)
                window.location.href = "/login";
                return;
            }

            if (error?.response?.status === 500) {
                message.error("Server not responding")
                return;
            }
            if (error?.response?.status === 403) {
                window.alert("Your subcription has been expired")
                localStorage.clear()
                // setIsAuthenticated(false)
                window.location.href = "/login";
                return;
            } else {
                return ;
            }
        } finally {
            setLoading(false)
        }

    }

    useEffect(() => {
        fetchSupportStaff()
    }, [action])

    const deleteSupportStaff = async () => {
        if(!selectedStaff) return ;

        try {
            setLoading(true)

            const response = await deleteStaff(selectedStaff.id)
             if (response.data.success) {
                    setAction(!action);
                    message.success(response?.data?.message);
                    setDeleteModalOpen(false);
                  }
        } catch (error) {
          console.log("Error while deleting subcontractor", error);
               message.error("Error while deleting subcontractor");
             } finally {
                setLoading(false)
             }
    }


    return (
        <div className="p-4">
            <div className="flex flex-row justify-between items-center mb-4">
                <h2 className="text-2xl font-bold">Support Staff Management</h2>
                <div className="flex justify-end items-end">
                    <button
                        onClick={handleCreateModalOpen}
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-12 rounded"
                    >
                        Create
                    </button>
                </div>
            </div>


            {/* Subcontractor Table */}
            <table className="min-w-full mt-7 bg-white border border-b-4 border-black">
                <thead>
                    <tr className="bg-gray-800 text-white">
                        <th className="py-2 px-4 border-b text-center">S.No</th>
                        <th className="py-2 px-4 border-b text-center">Name</th>
                        <th className="py-2 px-4 border-b text-center">Email</th>
                        {/* <th className="py-2 px-4 border-b text-center">Company Name</th> */}
                        <th className="py-2 px-4 border-b text-center">Status</th>
                        <th className="py-2 px-4 border-b text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems?.length > 0 ? (
                    currentItems?.map((staff, index) => (
                        <tr
                            key={staff.id}
                          className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
                        >
                            <td className="py-2 px-4 border-b">{index + 1}</td>
                            <td className="py-2 px-4 border-b">{staff?.firstName} {staff?.lastName}</td>
                            <td className="py-2 px-4 border-b">{staff?.email}</td>
                            <td className="py-2 px-4 border-b">
                            <span className={`py-0.5 px-2 text-[20px] font-medium w-fit ${staff.active ? "text-green-500" : "text-red-500"}`}>
                            {staff?.active ? "Active" : "Inactive"}
                    </span>
                                </td>

                            <td className="py-2 px-4 border-b">
                                <div className="flex flex-row justify-center">
                                    <button
                                        onClick={() => handleViewModalOpen(staff)}
                                        className="text-blue-500 hover:text-blue-700 flex items-center"
                                    >
                                        <AiOutlineEye className="mr-1 text-xl" />
                                    </button>
                                    <button
                                        onClick={() => handleEditModalOpen(staff)}
                                        className="mr-2 text-blue-500 hover:text-blue-700 flex items-center"
                                    >
                                        <AiFillEdit className="mr-1 text-xl" />
                                    </button>
                                    <button
                                        onClick={() => handleDeleteModalOpen(staff)}
                                        className="text-red-500 hover:text-red-700 flex items-center"
                                    >
                                        <AiFillDelete className="mr-1 text-xl" />
                                    </button>
                                </div>
                            </td>

                        </tr>
                    )

                    )) : (
                        <tr>
                        <td colSpan="7" className="py-2 px-4 border-b text-center">No Staff Found</td>
                      </tr>
                    )}

                </tbody>

            </table>
            {loading && (
                <Loader />
            )}

            <div className="mt-4 flex justify-end">
                      <Pagination
                        current={currentPage}
                        total={allStaff.length}
                        pageSize={itemsPerPage}
                        onChange={handlePageChange}
                        showSizeChanger={false}
                      />
                    </div>


                    {viewModalOpen && (
                        <ViewSupport
                        showViewModal={viewModalOpen}
                        setShowViewModal={setViewModalOpen}
                        action={action}
                        setAction={setAction}
                        selectedStaff={selectedStaff}
                        />
                    )
                    }

                    {showCreateModal && (
                        <CreateSupport
                           showAddModal={showCreateModal}
                           setShowAddModal={setShowCreateModal}
                           action={action}
                           setAction={setAction} 
                        />
                    )}


                    {editModalOpen && (
                        <EditSupport
                        showEditModal={editModalOpen}
                        setShowEditModal={setEditModalOpen}
                        action={action}
                        setAction={setAction}
                        selectedStaff={selectedStaff}
                        />
                    )}

                    <CustomModal
                    isOpen={deleteModalOpen}
                    title="Confirm Delete"
                    message="Are you sure you want to delete this support staff ?"
                    onConfirm={deleteSupportStaff}
                    onClose={handleDeleteModalClose}
                    />

        </div>

    )
}

export default SupportStaff